import React from "react";
import Chart from "react-apexcharts";
import type { ApexOptions } from "apexcharts";
import { ChatScoreCards } from "./chatAnalyticsService";

interface ChatAutomationGaugeProps {
  data: ChatScoreCards | null;
}

const ChatAutomationGauge: React.FC<ChatAutomationGaugeProps> = ({ data }) => {
  const evalData = data?.external_chat_message_evaluation;
  const totalReplies = (evalData?.total_agent_replies || 0) + (evalData?.total_bot_replies || 0);
  const pct = totalReplies ? Math.round(((evalData?.total_bot_replies || 0) / totalReplies) * 100) : 0;

  const options: ApexOptions = {
    chart: { type: "radialBar", height: 260, animations: { enabled: false } },
    series: [pct],
    plotOptions: {
      radialBar: {
        startAngle: -120,
        endAngle: 120,
        hollow: { size: "62%" },
        track: { background: "#efeafd", strokeWidth: "100%" },
        dataLabels: {
          name: { show: true, offsetY: 24, color: "#655f78", fontSize: "12px", fontWeight: 600 },
          value: { show: true, offsetY: -8, color: "#171123", fontSize: "34px", fontWeight: 700 },
        },
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "dark",
        type: "horizontal",
        gradientToColors: ["#14b8a6"],
        stops: [0, 100],
      },
      colors: ["#8b5cf6"],
    },
    stroke: { lineCap: "round" },
    labels: ["Automated"],
  } as ApexOptions;

  return (
    <div className="text-center">
      <Chart options={options} series={[pct]} type="radialBar" height={260} />
      <p className="text-muted fs-12 mb-0 mt-n2">
        {totalReplies
          ? `${pct}% of the ${totalReplies} replies sent were handled by a bot.`
          : "No replies were sent in this selection yet."}
      </p>
    </div>
  );
};

export default ChatAutomationGauge;
